import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Telegram = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 30 24"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <g clipPath="url(#Telegram_svg__a)">
        <path
          fill="#fff"
          d="M25.016 3.441a.55.55 0 0 0-.347-.403 1.83 1.83 0 0 0-.993.07S1.765 11.126.515 12.018c-.271.194-.347.304-.406.435-.216.633.458.91.458.91l5.645 1.874a.6.6 0 0 0 .285 0c1.285-.824 12.922-8.313 13.592-8.565.108-.031.184 0 .164.078-.268.962-10.374 10.114-10.374 10.114a.5.5 0 0 0-.063.11l-.542 5.678s-.218 1.748 1.497 0a49 49 0 0 1 2.965-2.766c1.954 1.365 4.038 2.876 4.933 3.665a1.56 1.56 0 0 0 1.143.449c.857-.032 1.093-.99 1.093-.99s3.993-16.37 4.128-18.563c0-.212.028-.354.032-.499q.01-.256-.049-.506"
        />
      </g>
      <defs>
        <clipPath id="Telegram_svg__a">
          <path fill="#fff" d="M.066 0h29.091v24H.067z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Telegram;
